import { render, staticRenderFns } from "./Bomb.vue?vue&type=template&id=5336485a&"
import script from "./Bomb.vue?vue&type=script&lang=js&"
export * from "./Bomb.vue?vue&type=script&lang=js&"
import style0 from "./Bomb.vue?vue&type=style&index=0&id=5336485a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports